<template>

  <div class="editor">
        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
            <div class="menubar">

                <button
                        type="button"
                        :class="{ 'is-active': isActive.paragraph() }"
                        @click="commands.paragraph"
                        class="menubar__button">
                    <i class="fa fa-paragraph"></i>
                </button>

                <button
                        type="button"
                        :class="{ 'is-active': isActive.heading({ level: 1 }) }"
                        @click="commands.heading({ level: 1 })"
                        class="menubar__button">
                    H1
                </button>

                <button
                        type="button"
                        :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                        @click="commands.heading({ level: 2 })"
                        class="menubar__button">
                    H2
                </button>

                <button
                        type="button"
                        :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                        @click="commands.heading({ level: 3 })"
                        class="menubar__button">
                    H3
                </button>

                <span class="px-2">
                  <!-- Spacer -->
                </span>

                <button
                        type="button"
                        :class="{ 'is-active': isActive.bullet_list() }"
                        @click="commands.bullet_list"
                        class="menubar__button">
                    <i class="fa fa-list-ul"></i>
                </button>

                <button
                        type="button"
                        :class="{ 'is-active': isActive.ordered_list() }"
                        @click="commands.ordered_list"
                        class="menubar__button">
                    <i class="fa fa-list-ol"></i>
                </button>

                <span class="px-2">
                  <!-- Spacer -->
                </span>

                <button
                        type="button"
                        :class="{ 'is-active': isActive.bold() }"
                        @click="commands.bold"
                        class="menubar__button">
                    <i class="fa fa-bold"></i>
                </button>

                <button
                        type="button"
                        :class="{ 'is-active': isActive.italic() }"
                        @click="commands.italic"
                        class="menubar__button">
                    <i class="fa fa-italic"></i>
                </button>

                <button
                        type="button"
                        :class="{ 'is-active': isActive.underline() }"
                        @click="commands.underline"
                        class="menubar__button">
                    <i class="fa fa-underline"></i>
                </button>

                <!--<button
                        @click="commands.undo"
                        class="menubar__button">
                    <i class="fa fa-undo"></i>
                </button>

                <button
                        @click="commands.redo"
                        class="menubar__button">
                    <i class="fa fa-repeat"></i>
                </button>-->

            </div>
        </editor-menu-bar>

        <EditorContent 
          :editor="editor"
          class="editor__content formated-content"
          :class="{ 'editor__is-invalid': isInvalid }"
        />

        <!--<button type="button" @click="exportHtml">EXPORT</button>-->
    </div>
</template>

<script>

import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Image
} from 'tiptap-extensions'

export default {
  components: {
    EditorContent,
    EditorMenuBar
  },
  props: {
    contentparent: {
      type: String,
      default: ''
    },
    isInvalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      text: '',
      editor: null
    }
  },
  beforeDestroy () {
    this.editor.destroy()
  },
  mounted () {
    let that = this
    this.editor = new Editor({
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new Image()
      ],
      content: this.contentparent,
      onUpdate (e) {
        that.$emit('eventEditorUpdated', e.getHTML())
      }
    })
    // this.editor.content = this.contentparent
  },
  methods: {
    exportHtml () {
    },
      setContent (content) {
          this.editor.setContent(content, false)
      },
    showImagePrompt (command) {
      const src = prompt('Entez l\'url de votre image')
      if (src !== null) {
        command({ src })
      }
    }
  },
    watch: {
        contentparent(newVal, oldVal){
            if(newVal != oldVal) {
                //this.editor.setContent(newVal, false)
            }
        }
    }
}
</script>

<style lang="scss">

</style>
